module.exports = __webpack_public_path__ + "static/media/7.e702d01b.jpeg";